import {
    MENU_ROLE,
    MENU_ROLE_SUCCESS,
    MENU_ROLE_ERROR
} from '../actions';

const INIT_STATE = {
    loading: true,
    init: true,
    menurole: {
        data: [],
        loading: true,
    },
    error: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case MENU_ROLE:
            return {
                ...state,
                loading: true,
                menurole: {
                    ...state.menurole,
                    loading: true,
                }
            }
        case MENU_ROLE_SUCCESS:
            return {
                ...state,
                loading: false,
                menurole: {
                    ...state.menurole,
                    ...action.payload,
                    loading: false,
                }
            }
        case MENU_ROLE_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        default:
            return { ...state };
    }

};